import { translateKey } from '.';

export function translatePatientTaskType(episodeCategoryName: string, patientTaskTypeName: string) {
    return translateKey(`${episodeCategoryName}PatientTaskType.${patientTaskTypeName}`);
}
